import { render, staticRenderFns } from "./ehc-interview.vue?vue&type=template&id=152b6d58&scoped=true"
import script from "./ehc-interview.vue?vue&type=script&lang=js"
export * from "./ehc-interview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b6d58",
  null
  
)

export default component.exports